import React from "react";
import { Box, Typography } from "@material-ui/core";
import clsx from "clsx";

import { useDeviceTypes } from "halifax";
import styles from "./styles.module.scss";
import { usePreviousFlight } from "../../hooks/usePreviousFlight";
import { PreviousFlightBannerLoading } from "./PreviousFlightBannerLoading";
import { AirlineDisplay } from "./AirlineDisplay";

export const PreviousFlightBanner = () => {
  const previousFlight = usePreviousFlight();
  const { matchesMobile } = useDeviceTypes();

  return (
    <Box
      className={clsx(styles["previous-flight-banner"], {
        mobile: matchesMobile,
      })}
    >
      <Box className={styles["previous-flight-banner__card"]}>
        <Typography
          variant="subtitle2"
          component="p"
          className={styles["previous-flight-banner__card-title"]}
        >
          <strong>Select a new flight</strong>
        </Typography>
        <Typography
          className={styles["previous-flight-banner__card-copy"]}
          variant="body2"
        >
          We've applied the base fare and taxes from your previous flight, along
          with any applicable airline change policies, to the new flights below.{" "}
          <strong>Only pay the fare difference shown (if any).</strong>
        </Typography>
      </Box>
      {previousFlight != null && (
        <Box className={styles["previous-flight-banner__card"]}>
          {previousFlight.isLoading ? (
            <PreviousFlightBannerLoading />
          ) : (
            <>
              <Typography
                variant="subtitle2"
                component="p"
                className={styles["previous-flight-banner__card-title"]}
              >
                <strong>{`Your previous flight to ${previousFlight.destinationName} (${previousFlight.destinationCode})`}</strong>
                {` on ${previousFlight.formattedDate}`}
              </Typography>
              <Box className={styles["flight-itinerary-details"]}>
                <Box>
                  <Typography
                    variant="body1"
                    className={styles["flight-itinerary-details__title"]}
                  >{`${previousFlight.departureTime} \u2013 ${previousFlight.arrivalTime}`}</Typography>
                  <Box>
                    {previousFlight.airlines.map(({ code, name }) => (
                      <AirlineDisplay key={code} name={name} code={code} />
                    ))}
                  </Box>
                </Box>
                <Box>
                  <Typography
                    variant="body1"
                    className={styles["flight-itinerary-details__title"]}
                  >
                    {previousFlight.flightDuration}
                  </Typography>
                  <Typography variant="body2">
                    {previousFlight.flightStops}
                  </Typography>
                </Box>
              </Box>
            </>
          )}
        </Box>
      )}
    </Box>
  );
};
